
import { mapState } from "vuex";
import ReportOrderDuration from "./report-order-duration.vue";
import reportOrderStages from "./report-order-stages.vue";
export default {
  components: { reportOrderStages, ReportOrderDuration },
  data() {
    return {
      items: [
        {
          value: "order-stages",
          label: "Order Stages"
        },
        {
          value: "order-duration",
          label: "Order Duration"
        }
      ]
    };
  },
  computed: {
    ...mapState("report", ["orderStages", "orderDuration"]),
    getSuccessRate() {
      return this.orderStages.new_order
        ? this.roundNumberWithTwoDecimal(
            ((this.orderStages.completed || 0) / this.orderStages.new_order) *
              100
          )
        : 0;
    }
  }
};
